export const PAGES = {
  ACCOUNT: 'account',
  ADD_SHOP: 'add-shop',
  EBAY_NOT_SUPPORTED: 'ebay-marketplace-not-supported',
  ADMIN: 'admin',
  AFFILIATE: 'affiliate',
  AUTH: 'auth',
  APPLICANTS: 'applicants',
  BILLING: 'billing',
  BULK_EDIT: 'bulk-edit',
  EDIT: 'edit',
  EDITOR: 'editor',
  LIBRARY: 'library',
  LISTINGS: 'listings',
  INFO: 'info',
  REFERRALS: 'referrals',
  STUDIO: 'studio',
  STUDIO_EDITOR: 'studio-editor',
  STUDIO_LIBRARY: 'studio-library',
  SCHEDULE: 'schedule',
  SCHEDULE_LISTINGS: 'schedule-listings',
  SCHEDULE_UPDATES: 'schedule-updates',
  PROFILES: 'profiles',
  PAYOUTS: 'payouts',
  RESET_PASSWORD: 'reset-password',
  SHOPS: 'shops',
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  USERS: 'users',
  UPDATES: 'updates',
  WELCOME: 'welcome',
};

export const PARAMS = {
  AFFILIATE: 'affiliate',
  EDIT: 'edit',
  LINK_DATA: 'linkData',
  LINK_ID: 'linkId',
  PAYOUT_ID: 'payoutId',
  PRODUCT_ID: 'productId',
  SHOP_ID: 'shopId',
  STATUS: 'status',
  USER_ID: 'userId',
  TYPE: 'type',
};

export const ROUTES = {
  ACCOUNT: {
    ROOT: `/${PAGES.ACCOUNT}`,
    AFFILIATE: `/${PAGES.AFFILIATE}`,
    BILLING: `/${PAGES.BILLING}`,
  },
  ADD_SHOP: `/${PAGES.ADD_SHOP}`,
  EBAY_NOT_SUPPORTED: `/${PAGES.EBAY_NOT_SUPPORTED}`,
  ADMIN: {
    ROOT: `/${PAGES.ADMIN}`,
    SHOPS: {
      ROOT: `/${PAGES.SHOPS}`,
      DETAILS: `/:${PARAMS.SHOP_ID}`,
    },
    USERS: {
      ROOT: `/${PAGES.USERS}`,
      DETAILS: `/:${PARAMS.USER_ID}`,
    },
    APPLICANTS: {
      ROOT: `/${PAGES.APPLICANTS}`,
    },
    PAYOUTS: {
      ROOT: `/${PAGES.PAYOUTS}`,
      DETAILS: `/:${PARAMS.PAYOUT_ID}`,
    },
    REFERRALS: {
      ROOT: `/${PAGES.REFERRALS}`,
      DETAILS: `/:${PARAMS.USER_ID}`,
    },
  },
  AFFILIATES: `/i/:${PARAMS.AFFILIATE}`,
  AUTH: {
    ROOT: `/${PAGES.AUTH}`,
    SIGN_IN: `/${PAGES.SIGN_IN}`,
    SIGN_UP: `/${PAGES.SIGN_UP}`,
    RESET_PASSWORD: {
      ROOT: `/${PAGES.RESET_PASSWORD}`,
      DETAILS: `/:${PARAMS.LINK_ID}?/:${PARAMS.LINK_DATA}?`,
    },
  },
  INFO: `/${PAGES.INFO}`,
  ROOT: '/',
  SHOP: {
    ROOT: `/:${PARAMS.SHOP_ID}`,
    LISTINGS: {
      ROOT: `/${PAGES.LISTINGS}`,
      BULK_EDIT: `/${PAGES.BULK_EDIT}`,
      EDIT: `/${PAGES.EDIT}/:${PARAMS.PRODUCT_ID}`,
      STATUS: `/:${PARAMS.STATUS}?`,
    },
    PROFILES: {
      ROOT: `/${PAGES.PROFILES}`,
      TYPE: `/:${PARAMS.TYPE}?`,
    },
    SCHEDULE: {
      ROOT: `/${PAGES.SCHEDULE}`,
      LISTINGS: `/${PAGES.LISTINGS}`,
      UPDATES: `/${PAGES.UPDATES}`,
    },
    STUDIO: {
      ROOT: `/${PAGES.STUDIO}`,
      EDITOR: `/${PAGES.EDITOR}`,
      LIBRARY: `/${PAGES.LIBRARY}`,
    },
  },
  WELCOME: `/${PAGES.WELCOME}`,
  WILDCARD: '/*',
};

export const PAGE_TO_ROUTE_MAP = {
  [PAGES.ACCOUNT]: ROUTES.ACCOUNT.ROOT,
  [PAGES.ADD_SHOP]: ROUTES.ADD_SHOP,
  [PAGES.ADMIN]: `${ROUTES.ADMIN.ROOT}${ROUTES.WILDCARD}`,
  [PAGES.AFFILIATE]: `${ROUTES.ACCOUNT.ROOT}${ROUTES.ACCOUNT.AFFILIATE}`,
  [PAGES.AUTH]: `${ROUTES.AUTH.ROOT}${ROUTES.WILDCARD}`,
  [PAGES.BILLING]: `${ROUTES.ACCOUNT.ROOT}${ROUTES.ACCOUNT.BILLING}`,
  [PAGES.BULK_EDIT]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.LISTINGS.ROOT}${ROUTES.SHOP.LISTINGS.BULK_EDIT}`,
  [PAGES.EDIT]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.LISTINGS.ROOT}${ROUTES.SHOP.LISTINGS.EDIT}`,
  [PAGES.LISTINGS]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.LISTINGS.ROOT}${ROUTES.SHOP.LISTINGS.STATUS}`,
  [PAGES.INFO]: ROUTES.INFO,
  [PAGES.STUDIO]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.STUDIO.ROOT}`,
  [PAGES.STUDIO_EDITOR]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.STUDIO.ROOT}${ROUTES.SHOP.STUDIO.EDITOR}`,
  [PAGES.STUDIO_LIBRARY]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.STUDIO.ROOT}${ROUTES.SHOP.STUDIO.LIBRARY}`,
  [PAGES.PROFILES]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.PROFILES.ROOT}${ROUTES.SHOP.PROFILES.TYPE}`,
  [PAGES.SCHEDULE]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.SCHEDULE.ROOT}`,
  [PAGES.SCHEDULE_LISTINGS]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.SCHEDULE.ROOT}${ROUTES.SHOP.SCHEDULE.LISTINGS}`,
  [PAGES.SCHEDULE_UPDATES]: `${ROUTES.SHOP.ROOT}${ROUTES.SHOP.SCHEDULE.ROOT}${ROUTES.SHOP.SCHEDULE.UPDATES}`,
  [PAGES.WELCOME]: ROUTES.WELCOME,
};

export const EXTERNAL_LINKS = {
  COMMUNITY_CENTER: 'https://getvela.com/community',
  HELP_CENTER: 'https://getvela.ai/help',
  COMMUNITY_CHANNEL: 'https://join.slack.com/t/velacommunity/shared_invite/zt-3837n6nv7-Si3aRGTllZ9onvEEKhTRGw',
  POSTER: {
    AFFILIATES: 'https://i.ytimg.com/vi/0jtwOh8kBi8/maxresdefault.jpg',
    INTRO: 'https://i.ytimg.com/vi/sUKGOQ4Cay8/maxresdefault.jpg',
  },
  VIDEO: {
    AFFILIATES: 'https://www.youtube.com/embed/0jtwOh8kBi8',
    INTRO: 'https://www.youtube.com/embed/sUKGOQ4Cay8',
  },
  WEBSITE: {
    PRICING: 'https://welcome.getvela.com/pricing',
  },
};

export const PAGE_NAME = {
  [PAGES.LISTINGS]: 'Listings',
  [PAGES.PROFILES]: 'Profiles',
  [PAGES.SCHEDULE]: 'Schedule',
  [PAGES.STUDIO]: 'Studio',
  [PAGES.BILLING]: 'Billing',
  [PAGES.AFFILIATE]: 'Affiliate',
  [PAGES.ACCOUNT]: 'Account settings',
};
